
import { ApplicationRef, Component, ComponentFactoryResolver, Injector, ViewChild, ViewContainerRef } from '@angular/core';

@Component({
  selector: 'ad-virtualContainer',
  template: `<ng-container #containerRef></ng-container>`,
})
export class AdVirtualViewContainer {
  @ViewChild('containerRef', { read: ViewContainerRef }) viewContainer: ViewContainerRef;
}

let _internalViewContainerRef: ViewContainerRef = null;

export class DefaultViewContainerRefProps {
  appRef: ApplicationRef;
  factoryResolver: ComponentFactoryResolver;
  injector: Injector;
}
export function getDefaultViewContainerRef({
  appRef,
  factoryResolver,
  injector,
}: DefaultViewContainerRefProps
): ViewContainerRef {
  if (_internalViewContainerRef === null) {
    const factory = factoryResolver.resolveComponentFactory(AdVirtualViewContainer);
    const compRef = factory.create(injector);
    compRef.changeDetectorRef.detectChanges();
    appRef.attachView(compRef.hostView);
    _internalViewContainerRef = compRef.instance.viewContainer;
  }
  return _internalViewContainerRef;
}

